module.exports = __webpack_public_path__ + "static/media/then_vs_now.c8f8977c.gif";